import React, { useState } from 'react';
import PageTemplate from '../components/PageTemplate';

const TravelPage = () => {
  const [showMore, setShowMore] = useState(false);

  return (
    <PageTemplate
      title="Travel Adventures"
      description="Welcome to our travel section! This page will be updated with travel stories, destinations, and adventures. Check back soon for exciting content about our journeys around the world."
      icon="fas fa-plane"
      maxWidth="default"
      padding="default"
    >
      <div className="section">
        <p>This page is currently under development. Future updates will include:</p>
        <ul>
          <li>Travel photo galleries</li>
          <li>Destination guides</li>
          <li>Adventure stories</li>
          <li>Travel tips and recommendations</li>
        </ul>
      </div>
    </PageTemplate>
  );
};

export default TravelPage;
